import { render, staticRenderFns } from "./initDataList.vue?vue&type=template&id=09809ed0&"
import script from "./initDataList.vue?vue&type=script&lang=js&"
export * from "./initDataList.vue?vue&type=script&lang=js&"
import style0 from "./initDataList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports